// extracted by mini-css-extract-plugin
export var arrowbtn = "carousel_timeline-module--arrowbtn--018db";
export var cards = "carousel_timeline-module--cards--2e5ce";
export var cta = "carousel_timeline-module--cta--ba3da";
export var forw = "carousel_timeline-module--forw--3a24a";
export var img = "carousel_timeline-module--img--759b3";
export var marker = "carousel_timeline-module--marker--2a29d";
export var off = "carousel_timeline-module--off--efd42";
export var t_btn = "carousel_timeline-module--t_btn--5c836";
export var timeline = "carousel_timeline-module--timeline--cb9e9";
export var timeline_wr = "carousel_timeline-module--timeline_wr--8e0cb";